// extracted by mini-css-extract-plugin
module.exports = {"widthContainer":"page-width_widthContainer__2pYxk"};